import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { ReactNode, useContext } from "react";

import styles from "../styles";

interface Props {
  children: ReactNode;
  inDialog: boolean;
}

const MainWrapper = ({ inDialog, children }: Props) => {
  const { upgradeDialogSource } = useContext(SubscriptionContext);

  return upgradeDialogSource || inDialog ? (
    <Grid container>{children}</Grid>
  ) : (
    <Box sx={styles.root}>{children}</Box>
  );
};

const LeftSidebarWrapper = ({ inDialog, children }: Props) => {
  const { upgradeDialogSource } = useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  return !isMobileScreen && (upgradeDialogSource || inDialog) ? (
    <Grid
      item
      xs={6}
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: "secondary.light",
      }}
    >
      {children}
    </Grid>
  ) : (
    <Grid item sx={styles.sidebar} container justifyContent="flex-end">
      {children}
    </Grid>
  );
};

const RightSidebarWrapper = ({ inDialog, children }: Props) => {
  const { upgradeDialogSource } = useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  return !isMobileScreen && (inDialog || upgradeDialogSource) ? (
    <Grid
      item
      xs
      sx={{
        p: { xs: 2, md: 4 },
      }}
      container
      alignItems="center"
    >
      {children}
    </Grid>
  ) : (
    <Grid item sx={styles.main} container alignItems="center">
      {children}
    </Grid>
  );
};

export { MainWrapper, LeftSidebarWrapper, RightSidebarWrapper };
